module.exports = __webpack_public_path__ + "static/img/party2.6984b0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/party2.png
// module id = bQVf
// module chunks = 1